import React, { ReactNode } from 'react';
import { getPerformanceBackground, getPerformanceColor } from '../../../utils/color-utils';
import { CellContainer, PendingPropertyIndicator, PropertyIndicatorContainer } from './utils';
import { PlatformBuyIcon } from '../../layout/nav-icons';
import { formatMetricPercentage } from '../../display/hero-metrics';
import { isNil } from 'lodash';

type Props = {
  value?: number | null;
  colorBase?: number | null;
  icon?: ReactNode;
};
export function PacingIndicator({ value, colorBase, icon }: Props) {
  if (isNil(value)) return null;

  if (value === 0) {
    return (
      <CellContainer>
        <PendingPropertyIndicator
          label={
            <div className="flex items-center gap-2">
              Pending
              {icon || <PlatformBuyIcon />}
            </div>
          }
        />
      </CellContainer>
    );
  }

  const background = getPerformanceBackground(value, colorBase || 1);
  const color = getPerformanceColor(value, colorBase || 1);

  return (
    <CellContainer>
      <PropertyIndicatorContainer style={{ background, color }}>
        <div className="text-center text-sm font-bold">{formatMetricPercentage(value)}</div>
      </PropertyIndicatorContainer>
    </CellContainer>
  );
}
